// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"0279ef92","251":"511097f3","570":"5052e3e4","925":"2bb75a5e"}[chunkId] + ".chunk.js";
};